import { useState, useEffect, useMemo } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  Button,
  Input,
  Spinner,
} from "reactstrap";
import { Icon } from "components/Component";
import { getDepartments } from "services/departments";
import { serviceGetProfile } from "services/settings";
import { getPermission } from "utils/Utils";

const LeadsMonitoringFilter = ({
  onLastInteractionFilter,
  lastInteractionRange,
  onExportCsv,
  isExporting,
  setLeadsFilter,
  departmentsFilter,
  setDepartmentsFilter,
  cookies,
  selectedFilterOptions,
  setSelectedFilterOptions,
  changeOption,
  setChangeOption,
  selectedSort,
  setSelectedSort,
  handleDate,
  startDate,
  endDate,
  filterStatus,
  setFilterStatus,
  filterUser,
  setFilterUser,
  loading,
  allUsers,
  selectedUser,
  onSelectUser,
  showAllUsers,
  customerPhoneSearch,
  onSearchCustomerPhone,
}) => {
  const [activeTab, setActiveTab] = useState(cookies.departmentIds);
  const [dataProfile, setDataProfile] = useState([]);

  const [Departments, setDepartments] = useState([]);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [userSearch, setUserSearch] = useState("");
  const [phoneSearchText, setPhoneSearchText] = useState(customerPhoneSearch || "");
  const statusOptions = ["RESOLVED", "OPENED", "UNOPENED", "PENDING", "SOLVED"];
  const lastInteractionOptions = [
    { label: "Semua Waktu", value: "" },
    { label: "7 - 60 Menit", value: "7-60min" },
    { label: "1 - 2 Jam", value: "1-2h" },
    { label: "2 - 3 Jam", value: "2-3h" },
    { label: "3 - 12 Jam", value: "3-12h" },
    { label: "> 12 Jam", value: "12h+" },
  ];

  let roleFunctions = getPermission()["lead-monitorings"]?.access || [];

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (departmentsFilter) {
    try {
      toggleTab(departmentsFilter);
    } catch (error) {
      // no initial dept
    }
  }

  async function getProfile() {
    try {
      const responseProfile = await serviceGetProfile(cookies.SIDikey);
      const resultData = responseProfile.data.departments;
      const finalData = resultData.map((department) => ({
        id: department.id,
        color: department.color,
        name: department.name,
      }));
      setDataProfile(finalData);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  }

  async function departmentsList() {
    const ALL_DEPT = "Access_All_Dept";

    try {
      const getDepartmentsData = await getDepartments(
        cookies.SIDikey,
        "",
        cookies.departmentIds,
        cookies.id,
        roleFunctions,
      );

      let finalDepts = [];
      if (roleFunctions.includes(ALL_DEPT)) {
        finalDepts = getDepartmentsData.data.data;
      } else if (cookies.departmentIds && cookies.departmentIds.length > 0) {
        finalDepts = getDepartmentsData.data.data.filter((item) => cookies.departmentIds.includes(item.id));
      }

      setDepartments(finalDepts);

      if (!departmentsFilter && finalDepts.length > 0) {
        setDepartmentsFilter(finalDepts[0].id);
        setActiveTab(finalDepts[0].id);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      setDepartments([]);
    }
  }

  useEffect(() => {
    getProfile();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPhoneSearchText(customerPhoneSearch || "");
  }, [customerPhoneSearch]);

  useEffect(() => {
    if (dataProfile.length > 0) {
      departmentsList();
    }
  }, [dataProfile]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleUserDropdown = () => {
    if (isUserDropdownOpen) {
      setUserSearch("");
    }
    setIsUserDropdownOpen((prev) => !prev);
  };

  const selectedUserLabel = selectedUser ? `${selectedUser.firstName} ${selectedUser.lastName}` : "Pilih User";
  const filteredUsers = useMemo(() => {
    const keyword = userSearch.trim().toLowerCase();
    const users = allUsers || [];

    if (!keyword) return users;

    return users.filter((user) => {
      const name = `${user.firstName || ""} ${user.lastName || ""}`.toLowerCase();
      const roleName = user.role?.name?.toLowerCase() || "";

      return name.includes(keyword) || roleName.includes(keyword);
    });
  }, [allUsers, userSearch]);

  const handleApplyPhoneSearch = () => {
    if (onSearchCustomerPhone) {
      onSearchCustomerPhone(phoneSearchText.trim());
    }
  };

  const handlePhoneSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      handleApplyPhoneSearch();
    }
  };

  const handleLastInteractionChange = (e) => {
    if (onLastInteractionFilter) onLastInteractionFilter(e.target.value);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <div>
        {/* Department tabs */}
        <Nav tabs>
          {Departments.map((item, index) => (
            <NavItem key={index}>
              <NavLink
                style={{ color: activeTab === item.id ? "#4461F2" : "", cursor: "pointer" }}
                onClick={() => {
                  toggleTab(item.id);
                  setDepartmentsFilter(item.id);
                }}
              >
                [{item.name}]
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {/* Active filter chips */}
        {/* <div
          className="data-filter-leads"
          style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}
        >
          {selectedFilter.map((item, index) => (
            <div className="filter-item" key={index}>
              <Dropdown
                key={index}
                isOpen={isFilterItemDropdownOpen === item.text}
                toggle={() => {
                  if (isFilterItemDropdownOpen !== item.text) {
                    setIsFilterItemDropdownOpen(item.text);
                    setKeepItemOpen(true);
                  } else {
                    setIsFilterItemDropdownOpen(null);
                    setKeepItemOpen(false);
                  }
                }}
              >
                <DropdownToggle caret outline>
                  {item.text}
                </DropdownToggle>
                <Card className="filter-item-wrap">
                  {item.type === "checkbox" ? (
                    <div>
                      <h5 className="sub-text d-flex justify-content-between align-items-center" style={{ width: 140 }}>
                        Filter {item.text}
                      </h5>
                      {item.options &&
                        [...item.options].map((opt, i) => (
                          <div className="filter-opt" key={i}>
                            <Input
                              type="checkbox"
                              id={opt + "" + i}
                              value={opt}
                              checked={
                                item.keyOptions === "ticket.status"
                                  ? isStatusChecked(opt, filterStatus)
                                  : item.keyOptions === "sales"
                                    ? isSalesChecked(opt, filterUser)
                                    : checkboxStatus[opt] || false
                              }
                              onChange={(e) => handleFilterCheckBox(item, e, i, item.options, item.keyOptions)}
                            />
                            <Label check htmlFor={opt + "" + i}>
                              {opt}
                            </Label>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <FormGroup className="">
                      <h6>{item.text}</h6>
                      <div className="d-flex">
                        <Input
                          name="filterdata"
                          placeholder={"Write " + item.text}
                          type="text"
                          className="input-filter mr-1"
                          value={getFilterValueForItem(item) || ""}
                          onChange={(e) => handleFilterInput(item, e.target.value)}
                        />
                        <Button size="sm" onClick={() => setChangeOption((c) => c + 1)}>
                          {loading ? <Spinner /> : "Filter"}
                        </Button>
                      </div>
                    </FormGroup>
                  )}
                </Card>
              </Dropdown>
            </div>
          ))}
        </div> */}
      </div>

      <div className="d-flex align-items-end justify-content-end">
        {/* User selector — hidden when showing all users at once */}
        {!showAllUsers && (
        <Dropdown isOpen={isUserDropdownOpen} toggle={toggleUserDropdown} className="mr-1">
          <DropdownToggle
            caret
            outline
            disabled={loading}
            color="primary"
            size="md"
            className="d-flex align-items-center"
            style={{ maxWidth: 180 }}
          >
            <Icon name="user-alt" />
            {loading && !selectedUser ? (
              <Spinner size="sm" />
            ) : (
              <span className="d-inline-block text-truncate" style={{ maxWidth: 130 }}>
                {selectedUserLabel}
              </span>
            )}
          </DropdownToggle>
          <DropdownMenu right style={{ minWidth: 240, marginRight: 12 }}>
            <div className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
              <Input
                bsSize="sm"
                type="text"
                placeholder="Cari user..."
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
              />
            </div>
            <div style={{ maxHeight: 220, overflowY: "auto" }}>
              {(!allUsers || allUsers.length === 0) && <DropdownItem disabled>Tidak ada user</DropdownItem>}
              {allUsers && allUsers.length > 0 && filteredUsers.length === 0 && (
                <DropdownItem disabled>User tidak ditemukan</DropdownItem>
              )}
              {filteredUsers.map((user, index) => (
                <DropdownItem
                  key={user.id || index}
                  active={selectedUser?.id === user.id}
                  onClick={() => {
                    onSelectUser(user);
                    setUserSearch("");
                    setIsUserDropdownOpen(false);
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between" style={{ minWidth: 200 }}>
                    <span className="d-inline-block text-truncate" style={{ maxWidth: 150 }}>
                      {user.firstName} {user.lastName}
                    </span>
                    {user.role?.name && (
                      <span
                        className="badge ml-2"
                        style={{
                          backgroundColor: user.role.name === "CS" ? "#0fac81" : "#4461F2",
                          color: "#fff",
                          fontSize: 10,
                          padding: "2px 6px",
                          borderRadius: 4,
                          flexShrink: 0,
                        }}
                      >
                        {user.role.name}
                      </span>
                    )}
                  </div>
                </DropdownItem>
              ))}
            </div>
          </DropdownMenu>
        </Dropdown>
        )}

        {/* Filter dropdown */}
        {/* <Dropdown
          isOpen={isFilterDropdownOpen}
          toggle={() => setIsFilterDropdownOpen((prev) => !prev)}
          className="mr-2"
        >
          <DropdownToggle caret outline disabled={loading}>
            {loading ? (
              <>
                Filter <Spinner size="sm" />
              </>
            ) : (
              "Filter"
            )}
          </DropdownToggle>
          <DropdownMenu right>
            {filterList.map((item, index) => (
              <DropdownItem key={index} className="d-flex align-items-center" onClick={() => handlefilterClick(item)}>
                <Icon name={item.icon} className="mr-2" />
                {item.text}
                {selectedFilter.findIndex((i) => i.text === item.text) >= 0 && (
                  <Icon name="check" className="ml-auto" />
                )}
              </DropdownItem>
            ))}
            <DropdownItem divider />
            <DropdownItem className="d-flex align-items-center" onClick={handleDeleteFilter}>
              <Icon name="trash" className="mr-2" />
              Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}

        {/* Sort dropdown */}
        {/* <Dropdown isOpen={isSortDropdownOpen} toggle={() => setIsSortDropdownOpen((prev) => !prev)} className="mr-2">
          <DropdownToggle caret outline disabled={loading}>
            {loading ? (
              <>
                Sort <Spinner size="sm" />
              </>
            ) : (
              "Sort"
            )}
          </DropdownToggle>
          <DropdownMenu right>
            {sortList.map((item, index) => (
              <DropdownItem key={index} className="d-flex align-items-center" onClick={() => handleSort(item)}>
                <Icon name={item.icon} className="mr-2" />
                {item.text}
                {item.query === selectedSort && <Icon name="check" className="ml-auto" />}
              </DropdownItem>
            ))}
            <DropdownItem divider />
            <DropdownItem className="d-flex align-items-center" onClick={handleDeleteSort}>
              <Icon name="trash" className="mr-2" />
              Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}

        {/* Date range picker */}
        {/* <FormGroup className="mb-0 w-100">
          <div className="form-control-wrap mr-2">
            <DatePicker
              disabled={loading}
              className="form-control date-picker"
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={handleDate}
              dateFormat={"yyyy-MM-dd"}
              isClearable={true}
            />
          </div>
        </FormGroup> */}

        {/* More options */}
        {/* <Dropdown isOpen={isMoreDropdownOpen} toggle={() => setIsMoreDropdownOpen((prev) => !prev)}>
          <DropdownToggle color="default" className="pl-1 pr-1">
            <Icon name="more-v" style={{ cursor: "pointer", fontSize: 16 }} />
          </DropdownToggle>
          <DropdownMenu right className="p-3">
            <p style={{ fontWeight: 600 }}>Options</p>
            <div
              className="d-flex justify-content-between align-items-center mb-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsPropertyDropdownOpen(true);
                setIsMoreDropdownOpen(false);
              }}
            >
              Properties
              <Icon name="forward-alt-fill" />
            </div>
          </DropdownMenu>
        </Dropdown> */}

        {/* <Dropdown isOpen={isGroupDropdownOpen} toggle={() => setIsGroupDropdownOpen((prev) => !prev)} className="mr-2">
          <DropdownToggle style={{ width: 0, height: 0, padding: 0, border: "none", margin: 0 }} />
          <DropdownMenu right>
            <p
              style={{ fontWeight: 600, marginBottom: 0, padding: 12, cursor: "pointer" }}
              onClick={() => {
                setIsGroupDropdownOpen(false);
                setIsMoreDropdownOpen(true);
              }}
            >
              <Icon name="back-alt-fill" className="mr-1" />
              Group By
            </p>
            {groupList.map((item, index) => (
              <DropdownItem key={index} className="d-flex align-items-center">
                <Icon name={item.icon} className="mr-2" />
                {item.text}
                <Icon name={item.isSelected ? "eye" : "eye-off"} className="ml-auto" />
              </DropdownItem>
            ))}
            <DropdownItem divider />
            <DropdownItem className="d-flex align-items-center">
              <Icon name="trash" className="mr-2" />
              Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}

        {/* <Dropdown
          onMouseLeave={() => setIsPropertyDropdownOpen(false)}
          isOpen={isPropertyDropdownOpen}
          className="mr-2"
        >
          <DropdownToggle style={{ width: 0, height: 0, padding: 0, border: "none", margin: 0 }} />
          <DropdownMenu right>
            <p
              style={{ fontWeight: 600, marginBottom: 0, padding: 12, cursor: "pointer" }}
              onClick={() => {
                setIsPropertyDropdownOpen(false);
                setIsMoreDropdownOpen(true);
              }}
            >
              <Icon name="back-alt-fill" className="mr-1" />
              Properties
            </p>
            {propertyList.map((item, index) => (
              <DropdownItem
                key={index}
                className="d-flex align-items-center"
                onClick={() => handleCLickedProperty(item)}
              >
                <Icon name={item.icon} className="mr-2" />
                {item.text}
                <Icon name={keyPropertyList[item.text] ? "eye" : "eye-off"} className="ml-auto" />
              </DropdownItem>
            ))}
            <DropdownItem divider />
            <DropdownItem className="d-flex align-items-center">
              <Icon name="trash" className="mr-2" />
              Delete
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}

        <Input
          bsSize="md"
          type="text"
          className="mr-1 "
          placeholder="Customer phone"
          value={phoneSearchText}
          onChange={(e) => setPhoneSearchText(e.target.value)}
          onKeyDown={handlePhoneSearchKeyDown}
          style={{ width: 150 }}
        />
        <Input
          bsSize="md"
          type="select"
          className="mr-1"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          style={{ width: 120 }}
        >
          <option value="">All Status</option>
          {statusOptions.map((status) => (
            <option key={status} value={status}>
              {status}
            </option>
          ))}
        </Input>

        {/* Last Interaction filter dropdown */}
        <Input
          bsSize="md"
          type="select"
          className="mr-1"
          value={lastInteractionRange}
          onChange={handleLastInteractionChange}
          disabled={loading}
          style={{ width: 150 }}
        >
          {lastInteractionOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Input>

        {/* Download CSV button */}
        <Button
          color="success"
          size="md"
          disabled={loading || isExporting}
          onClick={onExportCsv}
          className="d-flex align-items-center"
        >
          {isExporting ? (
            <Spinner size="sm" />
          ) : (
            <>
              <Icon name="download" className="mr-1" />
              CSV
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default LeadsMonitoringFilter;
